export const filterARCCONFIG = (props, prop = 'ARCConfig') => Object.keys(props).reduce((state, current) => current === prop ? state : {
    ...state,
    [current]: props[current]
}, {})